module.exports = __webpack_public_path__ + "static/OGImage-a56f42c0aad09796c7f46d2587317704.png";